import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from 'app/shared/restApiServices/restapi.service';
import { RenderZingChartService } from 'app/shared/services/render.zingchart.service';
import { superAdminService } from 'app/shared/services/superAdminService';
import * as L from 'leaflet';
import 'leaflet.markercluster';


declare var zingchart: any;
@Component({
  selector: 'app-data-analysis',
  templateUrl: './data-analysis.component.html',
  styleUrls: ['./data-analysis.component.css']
})
export class DataAnalysisComponent implements OnInit {
  userHeader:string;
  companyName:string;
  selectedVersion;
  qnrList = [];
  versions = [];
  numVersionResponses=[];
  questionIndex = 0;
  selectedQuestion:string;
  selectedQID:string;
  selectedSurveyName: string;
  childGroup:any;
  adminID:string;

  questionList:{index:number,qn:string,qnType:string,isRepeater:boolean,values:any[],
  optNames:string[]}[] = [];

  viewType:"graph"|"map" =  "graph";
  switchOrgList:{orgName:string,superAdminID:string}[]=[];
  superAdmin = false;


  // map....

  map: L.Map;
  markers: L.Marker[] = [];
  options1 = {
    layers: [
      L.tileLayer('http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        attribution: 'map'
      })
    ],
    zoom: 16,
    center: { lat: 28.626137, lng: 79.821603 }
  };
  initialMarkers: {position: { lat: number, lng: number },
  draggable: false,
  id:string}[] = [];
  unselected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-unselected.svg',
  });
  selected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-selected.svg',
  });
  markerClusterData: any[] = [];
  markerClusterGroup: L.MarkerClusterGroup;
  center=[20.5937, 78.9629];
  zoom = 4;
  responses = 0;
  merged = false;
  // map...

  constructor(private restApiService:RestApiService, private createChart: RenderZingChartService,
    private route:ActivatedRoute, private router: Router, 
    private superAdminService:superAdminService) { 
      this.route.queryParams.subscribe(query=>{
        if(query && query.qnr){
          localStorage.setItem('latestDataAnalysis',query.qnr);
          const qnr= JSON.parse(query.qnr);
          this.router.navigate([], {
            queryParams: {
              'qnr': null,
            },
            queryParamsHandling: 'merge'
          });
          this.merged = true;
          this.getQnrList();
          this.onSelectSurvey(qnr);
        }
        else if(!this.merged){
          this.getQnrList();
          this.generateMap(null);
        }
      },error=>{
        this.getQnrList();
        this.generateMap(null);
      })
      // checking if it is manager or not..
      if (this.superAdminService.hasData()) {
        this.superAdmin = this.superAdminService.getData();
      } else {
        this.restApiService.checkIfSuperAdmin().subscribe(
          result => {
            if (result.checkIfSuperAdmin == true) {
              this.superAdmin = true;
              this.superAdminService.setData(this.superAdmin);
            }
            else {
              this.superAdmin = false;
              this.superAdminService.setData(this.superAdmin);
            }
          });
      }
    }

  ngOnInit() {
    this.userHeader = localStorage.getItem("user_name_header");
    this.companyName = localStorage.getItem('companyName');
    this.switchOrgList = this.restApiService.getSwitchOrgList();
    // this.getQnrList();
    // // this.generateBarGraph();
    // this.generateMap(null);
  }

  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName = org.orgName;
      // this.restApiService.orgName.next(this.companyName);
      this.goToSurveys();
    }
  }


  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }

  getQnrList(){
    this.restApiService.getQnrListService().subscribe(
      result => {
        this.qnrList = result.result;
        if(this.qnrList && this.qnrList.length>0){
          // this.selectedQuestion = this.qnrList[0].question[0].Qn;
          // this.questionIndex = 0;
          if(!this.merged){
            this.selectedQID = this.qnrList[0].qID;
            this.selectedSurveyName = this.qnrList[0].surveyName;
          }
        }
        if(!this.merged){
          this.getAggDataForAnalyticsService();
        }
      });
  }


  onSelectSurvey(qnr){
    localStorage.setItem("selectedSIdForPerformance",qnr.qID);
    localStorage.setItem("selectedAdminIdForPerformance",qnr.adminID);
    localStorage.setItem("selectedSurveyName",qnr.surveyName);
    this.selectedSurveyName = qnr.surveyName;
    this.versions= qnr.versions;
    this.numVersionResponses = qnr.numVersionResponses;
    this.selectedVersion = null;
    // this.selectedQuestion = qnr.question[0].Qn;
    // this.questionIndex = 0;
    this.selectedQID = qnr.qID;
    this.adminID = qnr.adminID;
    this.childGroup = qnr.child_group;
    this.getAggDataForAnalyticsService();
  }

  loading = false;
  getAggDataForAnalyticsService(){
    this.loading =true;
    this.questionList = [];
    const version = this.selectedVersion? this.selectedVersion:null;
    this.restApiService.getAggDataForAnalyticsService(this.selectedQID,this.adminID,this.childGroup,
      version)
    .subscribe(response=>{
      if(response && response.success){
        const questions = response.question;
        const values = response.result;
        questions.forEach(question=>{
          if(question.Qn_Type != 'Picture Input' && question.Qn_Type != 'Subjective' 
          && !question.Qn_Type.toLowerCase().includes('naturalnum') && question.Qn_Type != 'Audio'
          && question.Qn_Type != 'Video' && question.Qn_Type != 'Document'
          && question.Qn_Type != 'Section Break' && question.Qn_Type != 'Time'
          && question.Qn_Type != 'Mobile Num' && question.Qn_Type != 'Repeater'
          && !question.Qn_Type.toLowerCase().includes('wholenum')
          && !question.Qn_Type.toLowerCase().includes('decimal')
          && question.Qn_Type != 'TextArea' && question.Qn_Type != 'MobileNumMAX10'
          && question.Qn_Type != 'Break'){
            this.questionList.push({index:question.Qn_Num,qn:question.Qn,qnType:question.Qn_Type,
              isRepeater:question.Repeater,values:values[question.Qn_Num],optNames:question.Opt_Name});
          }
        });

        if(this.questionList && this.questionList.length>0){
          this.selectedQuestion = this.questionList[0].qn;
          this.questionIndex= 0;
          const question = this.questionList[0];
          // const values2 = question.values? [...question.values]:[];
          let values2;
          const qnType = question.qnType;
          if(qnType == 'Button' || qnType == 'Map'){
            values2 = question.values;
            this.responses = values2.length;
          }
          else{
            this.responses = 0;
            values2 = question.values? Object.values(question.values):[];
            for (let index = 0; index < values2.length; index++) {
              values2[index] = Number(values2[index]);
              if(values2[index]){
                this.responses = values2[index] + this.responses;
              }
            }
          }
          let options = question.optNames;
          if(qnType == 'Radio'|| qnType == 'Checkbox' || qnType == 'Selected Dropdown'
           || qnType == 'Rating' || qnType == 'Emoji' || qnType == 'CalendarWithDate'){
            options = Object.keys(question.values);
           }
          this.showMapOrGraphs(question.qnType,values2,options);
        }
        this.loading =false; 
      }
      else{
        this.loading =false; 
      }
    },error=>{
      this.loading =false;
    })
  }

  showMapOrGraphs(qnType, values,options){
    if(qnType == 'Radio'|| qnType == 'Checkbox' || qnType == 'Selected Dropdown'
     || qnType == 'Rank' || qnType == 'Rating' || qnType == 'Emoji'){
      this.viewType = 'graph';
      this.generatePieChart(values,options);
     }
    if(qnType == 'CalendarWithDate'){
      this.viewType = 'graph';
      this.generateBarGraph(values,options);
    }
    if(qnType == 'Map'){
      this.viewType = 'map';
      this.getMapViewForSurvey(values);
    }
    if(qnType == 'Button'){
      this.viewType = 'graph';
      this.generateCascadeGraph(values);
    }
  }

  onSelectVersion(version){
    this.selectedVersion = version;
    this.getAggDataForAnalyticsService();
  }

  onSelectAllVersion(){
    this.selectedVersion = null;
    this.getAggDataForAnalyticsService();
  }

  viewPreviewQuestion(){
    this.loading = true;
    if(this.questionIndex!=0 && this.questionList.length>0 ){
      this.questionIndex = this.questionIndex -1;
      const question = this.questionList[this.questionIndex];
      this.selectedQuestion = question.qn;
      // const values = question.values? [...question.values]:[];
      let values;
      const qnType = question.qnType;
      if(qnType == 'Button' || qnType == 'Map'){
        values = question.values;
        this.responses = values.length;
      }
      else{
        this.responses = 0;
        values = question.values? Object.values(question.values):[];
        for (let index = 0; index < values.length; index++) {
          values[index] = Number(values[index]);
          if(values[index]){
            this.responses = values[index] + this.responses;
          }
        }
      }
      let options = question.optNames;
      if(qnType == 'Radio'|| qnType == 'Checkbox' || qnType == 'Selected Dropdown'
       || qnType == 'Rating' || qnType == 'Emoji'|| qnType == 'CalendarWithDate'){
        options = Object.keys(question.values);
       }
      this.showMapOrGraphs(question.qnType,values,options);
    }
    this.loading = false;
  }
  viewNextQuestion(){
    this.loading = true;
    if(this.questionList.length>0 && this.questionIndex!= this.questionList.length -1){
      this.questionIndex = this.questionIndex +1;
      const question = this.questionList[this.questionIndex];
      this.selectedQuestion = question.qn;
      // const values = question.values? [...question.values]:[];
      let values;
      const qnType = question.qnType;
      if(qnType == 'Button' || qnType == 'Map'){
        values = question.values;
        this.responses = values.length;
      }
      else{
        this.responses = 0;
        values = question.values? Object.values(question.values):[];
        for (let index = 0; index < values.length; index++) {
          values[index] = Number(values[index]);
          if(values[index]){
            this.responses = values[index] + this.responses;
          }
        }
      }
      let options = question.optNames;
      if(qnType == 'Radio'|| qnType == 'Checkbox' || qnType == 'Selected Dropdown'
       || qnType == 'Rating' || qnType == 'Emoji'|| qnType == 'CalendarWithDate'){
        options = Object.keys(question.values);
       }
      this.showMapOrGraphs(question.qnType,values,options);
    }
    this.loading = false;
  }

  generatePieChart(values,options){
    const bgColors = ['#009688','#FFA17A','#E39217','#1F78C1','#965D08','#7163B4','#344B47','#48B691',
    '#928719','#F97DEA'];
    let myConfig = this.configPieChart(values,bgColors,options);
    this.renderZingChart(myConfig);
  }

  generatePieChart2(){
    let myConfig = {
      "type": "pie",
      "legend": {
        'toggle-action': "remove", //"hide" (default), "remove", or "disabled"
        'background-color': "#FFFFFF",
        'border-width':0,
        'border-color': "#FFFFFF",
        "align":"center",
        "vertical-align":"bottom"
      },
      "series": [{
          "values": [59],
          'background-color': "#E0F6EA",
          'legend-text': "Test 1"
        },
        {
          "values": [55],
          'background-color': "#004A43",
          'legend-text': "Test 2"
        },
        {
          "values": [30],
          'background-color': "#FFA17A",
          'legend-text': "Test 3"
        },
        {
          "values": [28],
          'background-color': "Responses",
          'legend-text': "Test 4"
        },
        {
          "values": [15],
          'legend-text': "Test 5"
        }
      ],
      gui: {
        contextMenu: {
          button: {
            visible: false
          }
        }
      }
    };
     
    this.renderZingChart(myConfig);
  }

  generateBarGraph(values,options){
    const xLables = options;
    const bgColor= '#009688';
    let myConfig = this.configBarGraph(xLables,values,bgColor);
    this.renderZingChart(myConfig);
  }

  generateCascadeGraph(values){
    let sunchartData: SunBurstChartDataModel[] = [{ id: 'Main', text: '', parent: '' }];

    let xLabels = [];
    let parentsAtlevel = [[], [], [], []];
    let indexArray = [];
    for (let data in values) {
      if (values[data] && values[data] != -1) {
        let resultLine = JSON.parse(values[data]);
        if (typeof (resultLine) == 'object' && resultLine.length && resultLine.length > 0) {
          let index = 0;
          let createNew: boolean;

          while (index < 4) {
            if (resultLine[index] && resultLine[index] != 'null' && resultLine[index] != -1) {
              if (parentsAtlevel[index].indexOf(resultLine[index]) > -1) {

                if (index == 3) {
                  let indexOfValueInParentArray = parentsAtlevel[index].indexOf(resultLine[index])
                  sunchartData[indexArray[indexOfValueInParentArray]]['value']++;
                }
                index++;
              }
              else {
                parentsAtlevel[index].push(resultLine[index]);
                createNew = true;
              }
              if (createNew) {
                if (index == 0) {
                  sunchartData.push({ id: resultLine[index], text: resultLine[index], parent: "Main" })
                }
                else if (index > 0 && index < 3) {
                  sunchartData.push({ id: resultLine[index], text: resultLine[index], parent: resultLine[index - 1] })
                }
                else {
                  indexArray.push(sunchartData.length);
                  sunchartData.push({ 'value': 1, id: resultLine[index], text: resultLine[index], parent: resultLine[index - 1] });
                }
                index++;
              }
            }
            else {
              index++;
              break;
            }
          }
        }
      }
    }

    let config = this.createChart.sunBurstPie({
      "data": sunchartData
    });
    // console.log("config...",config)
    // this.createChart.renderZingCharts('dataAnalysisGraphs', config);
    zingchart.render({
      id: 'dataAnalysisGraphs',
      data: config,
      height: 425,
      width: "100%"
    });
  }

  generateStackGraph(){
    const xLables = ['Option A', 'Option B', 'Option C', 'Option D','Option E', 'Option F', 'Option G'
    , 'Option H'];
    const bgColors = ['#009688','#FFA17A','#E39217','#1F78C1','#965D08','#7163B4','#344B47','#48B691',
    '#928719','#F97DEA'];
    const legendText = ['Cascade A','Cascade B']
    const valueSets: {values:number[]}[] = [{values:[20, 40, 25, 50, 15, 45, 33, 34]},
                                            {values:[5, 30, 21, 18, 59, 50, 28, 33]}]
    let myConfig = this.configStackedBarGraph(xLables,valueSets,bgColors,legendText);
    this.renderZingChart(myConfig);
  }

  configPieChart(values:number[],backgroundColor:string[],legendText:string[],){
    let series : {values:number[],backgroundColor:string,legendText:string}[] = [];
    for (let index = 0; index < values.length; index++) {
      series.push({values:[values[index]],backgroundColor:backgroundColor[index],
        legendText:legendText[index]});
    }
    let myConfig = {
      "type": "pie",
      "legend": {
        'toggle-action': "remove", //"hide" (default), "remove", or "disabled"
        'background-color': "#FFFFFF",
        'border-width':0,
        'border-color': "#FFFFFF",
        "align":"center",
        "vertical-align":"bottom"
      },
      "series": series,
      gui: {
        contextMenu: {
          button: {
            visible: false
          }
        }
      }
    };
    return myConfig;
  }

  configBarGraph(xLables:string[],values:number[],bgColor:string){
    let myConfig = {
      type : "bar",
      plot: {
        stacked: true,
        borderRadiusTopLeft:1000,
        borderRadiusTopRight:1000,
        "border-width": 0,
        "tooltip": { //Standard Tooltips
          "text": "%v <br> %kl",
          "placement": "node:top",
          "padding": "10%",
          "border-radius": "5px"
        }
      },
      scaleX: {
        labels: xLables
      },
      series: [{
        values: values,
        'background-color':bgColor
      }]
    }
    return myConfig;
  }

  configStackedBarGraph(xLables:string[],valueSets:{values:number[]}[],bgColors:string[],
    legendText:string[]){
    let series: any[] = [];
    let index = 0;
    valueSets.forEach(data=>{
      let seriesValue:any = {
        values: data.values,
        stack: 1,
        'background-color': index <=10?bgColors[index]:'',
        'legend-text': legendText[index]
      }
      if(index == valueSets.length - 1){
        seriesValue.borderRadiusTopLeft = 1000;
        seriesValue.borderRadiusTopRight = 1000;
      }
      index = index +1;
      series.push(seriesValue);
    })
    let myConfig = {
      type : "bar",
      plot: {
        stacked: true,
      },
      legend: {
        'background-color': "#FFFFFF",
        'border-width':0,
        'border-color': "#FFFFFF",
        "align":"center",
        "vertical-align":"bottom"
      },
      scaleX: {
        labels: xLables
      },
      series: series
    }
    return myConfig;
  }

  generateBarGraph2(){
    let myConfig = {
      type: "bar",
      plot: {
        stacked: true,
        'border-radius': "100px"
      },
      "legend": {
        'background-color': "#FFFFFF",
        'border-width':0,
        'border-color': "#FFFFFF",
        "align":"center",
        "vertical-align":"bottom"
      },
      scaleX: {
        labels: ['Option A', 'Option B', 'Option C', 'Option D','Option E', 'Option F', 'Option G'
      , 'Option H']
      },
      series: [{
          values: [20, 40, 25, 50, 15, 45, 33, 34],
          stack: 1,
          'background-color': "#004A43",
          'legend-text': "Cascade A"
        },
        {
          values: [5, 30, 21, 18, 59, 50, 28, 33],
          stack: 1,
          'background-color': "#E0F6EA",
          'legend-text': "Cascade B",
        }
      ]
    };
     
    this.renderZingChart(myConfig);
  }

  renderZingChart(myConfig){
    zingchart.render({
      id: 'dataAnalysisGraphs',
      data: myConfig,
      height: 425,
      width: "100%"
    });
    zingchart.bind('dataAnalysisGraphs', 'contextmenu', function(p) { return false;});
  }



  mapValues:{name:string,date:string}[]=[];
  getMapViewForSurvey(response){
    if(response && response.length>0){
      let values = [];
      response.forEach(data=>{
        if(data){
          values.push(JSON.parse(data));
        }
      })
      if(values && values.length>0){
        this.generateMap(values);
      }
    }
  }


  onMapReady($event: L.Map) {
    this.map = $event;
    this.initMarkers();
  }
  
  initMarkers() {
    for (let index = 0; index < this.initialMarkers.length; index++) {
      const data = this.initialMarkers[index];
      const marker = this.generateMarker(data, index);
      marker.addTo(this.map).setIcon(this.unselected);
      this.map.panTo(data.position);
      this.markers.push(marker)
    }
  }
  generateMarker(data: any, index: number) {
    return L.marker(data.position, { draggable: data.draggable })
      .on('click', (event) => this.markerClicked(event, index))
      .on('dragend', (event) => this.markerDragEnd(event, index));
  }

  markerClicked($event: any, index: number) {
    const id= this.initialMarkers[index].id
    const position= this.initialMarkers[index].position;
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = $event;
  }

  markerDragEnd($event: any, index: number) {
    console.log($event.target.getLatLng());
  } 

  markerClusterReady(group: L.MarkerClusterGroup) {
    this.markerClusterGroup = group;
    let lat1, lng1;
    this.markerClusterGroup.options.iconCreateFunction = function (cluster) {
      return L.divIcon({ html: '<b style="padding:4px; background-color: #FFA17A; text-align: center;font-size: 12px; border-radius:50%; color:#FFFFFF"; font-weight: 500;font-family: "Roboto";font-style: normal;line-height: 14px;">' + cluster.getChildCount() + '</b>', className: 'my-div-icon', iconSize: L.point(40, 40),
      iconAnchor: L.point(7, 12) });
    }
    this.markerClusterGroup.options.maxClusterRadius = 10;
    this.markerClusterGroup.options.singleMarkerMode = true;
  }
  mapClicked($event: any) {
    $event.target.setIcon(this.selected);
    this.zoom=20;
    this.center = [$event.latlng.lat, $event.latlng.lng]
  }

  generateMap(response){
    this.markerClusterData = [];
    this.initialMarkers = [];
    this.zoom = 4;
    this.center = [20.5937, 78.9629];
    let count = 1;
    for (let i in response) {
      this.initialMarkers.push({position: {lat: parseFloat(response[i].lat), 
        lng: parseFloat(response[i].lng)},
        draggable:false, id: count.toString()});
      this.markerClusterData.push(L.marker([parseFloat(response[i].lat),parseFloat(response[i].lng)],
        {'id': count.toString()}).setIcon(this.unselected).on('click', this.onclick.bind(this)));
      count = count +1;
    }
  }
  prevclick: any;
  onClickItem = false;
  surveyorName:string;
  surveyorDate:string;
  onclick = (e) => {
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = e;
    this.onClickItem = true;
    e.target.setIcon(this.selected);
    const index = +e.target.options.id - 1;
    this.surveyorName = this.mapValues[index].name;
    this.surveyorDate = this.mapValues[index].date;
  };
  // route to home page...
  goToSurveys(){
    this.router.navigate(['./questionnaires']);
  }
  // route to responses page...
  goToResponses(){
    const qnr = localStorage.getItem('latestDataAnalysis');
    if(qnr && qnr != undefined){
      this.viewResponses(qnr);
    }
  }

  viewResponses(qnr){
    this.router.navigate(['./survey-data'],{
      queryParams:{
        'qnr':qnr
      },
      queryParamsHandling: 'merge'
    })
  }
}

interface SunBurstChartDataModel {
  'value'?: number,
  id?: string,
  text?: string,
  parent?: string
};



// WEBPACK FOOTER //
// ./src/app/data-analysis/data-analysis.component.ts